import { equals, last } from "ramda";
import { useEffect, useRef, useSyncExternalStore } from "react";
function callMethod(obj, method, ...args) {
    let pathValue = method.split(".");
    let ref = obj;
    for (let i = 0; i < pathValue.length - 1; i++) {
        let path = pathValue[i];
        ref = ref[path];
        if (typeof ref !== "object") {
            console.error(`${method} not found`, obj);
            return;
        }
    }
    if (typeof ref[last(pathValue)] !== "function") {
        console.error(`${method} not on ${obj}`);
        return;
    }
    return ref[last(pathValue)](...args);
}
class Store {
    listeners = {};
    state = {};
    actionsQueue = [];
    register(key, obj) {
        this.state[key] = obj;
        //this.notify({type: "register", value: obj, key});
    }
    inRegister(key) {
        return this.state[key];
    }
    unregister(key) {
        //delete this.state[key];
        this.state[key] = null;
    }
    dispatch(key, method, ...args) {
        this.actionsQueue.push({ key, method, args });
        const obj = this.state[key];
        if (!obj) {
            console.error(`${key} not found`);
            return;
        }
        let res = callMethod(obj, method, ...args);
        this.notify({ type: method, value: args, key });
        return res;
    }
    getSnapshot = () => this.state;
    getServerSnapshot = () => this.state;
    subscribe(key, listener) {
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
        }
        this.listeners[key].add(listener);
        return () => this.listeners[key].delete(listener);
    }
    notify(event) {
        if (!this.listeners[event.key]) {
            return;
        }
        this.listeners[event.key].forEach(l => l(event));
    }
}
export const store = new Store();
export function useStoreRegister(key, obj) {
    useEffect(() => {
        if (store.inRegister(key)) {
            console.warn(`${key} already registered, overwriting`);
        }
        store.register(key, obj);
        return () => store.register(key, obj);
    }, []);
}
export function useStoreDispatch(key, method, ...args) {
    useEffect(() => {
        store.dispatch(key, method, ...args);
    }, []);
}
function setValues(obj, values) {
    //Same references, return the same object
    if (obj.current === values) {
        return obj.current;
    }
    if (!equals(obj.current, values)) {
        obj.current = values;
    }
    return obj.current;
}
export function useStoreSelect(key, selector) {
    const cache = useRef({});
    // if(!key) {
    //   console.error(`Error calling useStoreSelect: ${key}`);
    //   return undefined;
    // }
    // if(!store.inRegister(key)) {
    //   console.error(`${key} not found, please provide a valid key`);
    //   return undefined;
    // }
    const selectorFunction = (key) => {
        let obj = store?.getSnapshot()?.[key];
        if (!obj) {
            console.error(`${key} not found, please provide a valid key`);
            return undefined;
        }
        let values = selector(obj);
        return setValues(cache, values);
    };
    return useSyncExternalStore((cb) => store.subscribe(key, cb), () => selectorFunction(key), () => selectorFunction(key));
}
